import o from"vue";import t from"./mixins.js";import{defineProp as e}from"./props.js";import r from"./base.js";import{withVisible as n}from"./common.js";var p=["LT","RT","LB","RB"],i=t(r,n(!0)).extend({amapMeta:{add:function(o,t){o.target.addControl(t)},remove:function(o,t){o.target.removeControl(t)},events:["show","hide"]}}),m=o.extend({props:{offset:e({type:Array})}}),s=o.extend({props:{position:e({type:[Object,String],validator:function(o){return"object"==typeof o||p.includes(o)}})}});export{p as ControlPositions,i as baseControl,m as withOffset,s as withPosition};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/mixins/control.js
// module id = null
// module chunks = 